import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: "hash", //路由模式
  base: "/web/pc_website_template", //部署的子路径

  routes: [{
      path: '/',
      redirect: '/index'
    },

    //访问home时，重定向到wellcome页
    {
      path: '/index',
      name: 'index',
     component: () => import('@/view/index'),
    },
    {
      path: '/news-list',
      name: 'news-list',
     component: () => import('@/view/news-list'),
    },
    {
      path: '/game-list',
      name: 'game-list',
     component: () => import('@/view/game-list'),
    },
    {
      path: '/detail',
      name: 'detail',
     component: () => import('@/view/detail'),
    },
    {
      path: '/image-list',
      name: 'image-list',
     component: () => import('@/view/image-list'),
    },
    {
      path: '/video-list',
      name: 'video-list',
     component: () => import('@/view/video-list'),
    },
    {
      path: '/card-list',
      name: 'card-list',
     component: () => import('@/view/card-list'),
    },
    {
      path: '/coop-list',
      name: 'coop-list',
     component: () => import('@/view/coop-list'),
    },
    {
      path: '/video-detail',
      name: 'video-detail',
     component: () => import('@/view/video-detail'),
    },
    {
      path: '/registration',
      name: 'registration',
     component: () => import('@/view/registration/registration'),
    },
    {
      path: '/registration/registration-detail',
      name: 'registration-detail',
     component: () => import('@/view/registration/registration-detail'),
    },
    {
      path: '/certificate-download',
      name: 'certificate-download',
     component: () => import('@/view/certificate-download/certificate-download'),
    },
    {
      path: '/image-detail',
      name: 'image-detail',
     component: () => import('@/view/image-detail'),
    },
    // 登协
    {
      path: '/mountain-game-list',
      name: 'mountain-game-list',
     component: () => import('@/view/mountain-game-list'),
    },
    {
      path: '/mountain-training-list',
      name: 'mountain-training-list',
     component: () => import('@/view/mountain-training-list'),
    },
    {
      path: '/mountain-scoreboard',
      name: 'mountain-scoreboard',
     component: () => import('@/view/mountain-scoreboard'),
    },
    {
      path: '/mountain-player-list',
      name: 'mountain-player-list',
     component: () => import('@/view/mountain-player-list'),
    },
    {
      path: '/mountain-player-detail',
      name: 'mountain-player-detail',
     component: () => import('@/view/mountain-player-detail'),
    },
    {
      path: '/mountain-media-list',
      name: 'mountain-media-list',
     component: () => import('@/view/mountain-media-list'),
    },
    {
      path: '/mountain-policy',
      name: 'mountain-policy',
     component: () => import('@/view/mountain-policy'),
    },
    {
      path: '/mountain-login',
      name: 'mountain-login',
     component: () => import('@/view/mountain-login'),
    },
    {
      path: '/mountain-person-center',
      name: 'mountain-person-center',
     component: () => import('@/view/mountain-person-center'),
    },
    {
      path: '/mountain-login-register',
      name: 'mountain-login-register',
     component: () => import('@/view/mountain-login-register'),
    }

  ]
})


export default router

//防止报路由重复
  const originalPush = VueRouter.prototype.push
  VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
  }



// WEBPACK FOOTER //
// ./src/router/index.js